const PathContants = {
	Home: "/",
	Login: "/login",

	Auth: "/auth",
	AuthSignup: "/auth/signup",
	AuthFindId: "/auth/find-id",
	AuthFindPassword: "/auth/find-password",

	PPF: "/ppf",

	Brand: "/brand",
	Partner: "/partner",

	Support: "/support",
	SupportNotice: "/support/notice",
	SupportContact: "/support/contact",
	SupportNoticeDetail: "/support/notice/:id",
	SupportCertificate: "/support/certificate", // 보증서 발급

	TermsDetail: "/terms/:id",

	Me: "/me",
	MeDetail: "/me/detail",
	meInquiry: "/me/inquiry",
	meInquiryDetail: "/me/inquiry/:id",
};

export default PathContants;
